import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import t from "../Map.js";
import i from "../TimeExtent.js";
import r from "../core/Accessor.js";
import a from "../core/Collection.js";
import s from "../core/CollectionFlattener.js";
import o from "../core/Error.js";
import n from "../core/Evented.js";
import { HandleOwnerMixin as l } from "../core/HandleOwner.js";
import { makeHandle as p } from "../core/handleUtils.js";
import d from "../core/Loadable.js";
import h from "../core/Logger.js";
import { isSome as y, destroyMaybe as u, abortMaybe as c } from "../core/maybe.js";
import { EsriPromiseMixin as m } from "../core/Promise.js";
import { createTask as f, after as g } from "../core/promiseUtils.js";
import { react as w } from "../core/reactiveUtils.js";
import { whenOnce as v, whenFalseOnce as M } from "../core/watchUtils.js";
import { aliasOf as V } from "../core/accessorSupport/decorators/aliasOf.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import "../core/accessorSupport/ensureType.js";
import { property as R } from "../core/accessorSupport/decorators/property.js";
import { subclass as _ } from "../core/accessorSupport/decorators/subclass.js";
import { owningCollectionProperty as S } from "../core/support/OwningCollection.js";
import j from "../geometry/Extent.js";
import F from "../geometry/HeightModelInfo.js";
import O from "../geometry/SpatialReference.js";
import { AnalysesCollection as L } from "../support/AnalysesCollection.js";
import { GraphicsCollection as E } from "../support/GraphicsCollection.js";
import { BasemapView as b } from "./BasemapView.js";
import C from "./LayerViewManager.js";
import x from "./Magnifier.js";
import I from "./ToolViewManager.js";
import q from "./input/Input.js";
import { ViewEvents as D } from "./input/ViewEvents.js";
import T from "./navigation/Navigation.js";
import k from "./support/DefaultsFromMap.js";

var _z;

var P = h.getLogger("esri.views.View");

var U = _z = /*#__PURE__*/function (_l) {
  _inherits(z, _l);

  var _super = _createSuper(z);

  function z(e) {
    var _this;

    _classCallCheck(this, z);

    _this = _super.call(this, e), _this._userSpatialReference = null, _this._cursor = null, _this.allLayerViews = new s({
      getCollections: function getCollections() {
        var e, t, i;
        return [null == (e = _this.basemapView) ? void 0 : e.baseLayerViews, null == (t = _this.groundView) ? void 0 : t.layerViews, _this.layerViews, null == (i = _this.basemapView) ? void 0 : i.referenceLayerViews];
      },
      getChildrenFunction: function getChildrenFunction(e) {
        return e.layerViews;
      }
    }), _this.groundView = null, _this.animation = null, _this.basemapView = null, _this.fatalError = null, _this.extent = null, _this.graphics = new E(), _this.analyses = new L(), _this.navigating = !1, _this.typeSpecificPreconditionsReady = !0, _this.layerViews = new a(), _this.magnifier = new x(), _this.padding = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    }, _this.ready = !1, _this.spatialReferenceWarningDelay = 1e3, _this.supportsGround = !0, _this.timeExtent = null, _this.type = null, _this.scale = null, _this.updating = !1, _this.initialExtentRequired = !0, _this.input = new q(), _this.navigation = new T(), _this.layerViewManager = null, _this.analysisViewManager = null, _this.isHeightModelInfoRequired = !1, _this.width = null, _this.height = null, _this.resizing = !1, _this.suspended = !1, _this.viewEvents = new D(_assertThisInitialized(_this)), _this.persistableViewModels = new a(), _this._isValid = !1, _this._readyCycleForced = !1, _this.handles.add(_this.watch("preconditionsReady", function (e) {
      var t, i;
      (e ? (_this._currentSpatialReference = _this.spatialReference, _z.views.add(_assertThisInitialized(_this))) : (_this._currentSpatialReference = null, _z.views.remove(_assertThisInitialized(_this))), _this.notifyChange("spatialReference"), !e && _this.ready) ? (null == (t = _this.layerViewManager) || t.clear(), null == (i = _this.toolViewManager) || i.detach(), y(_this.analysisViewManager) && _this.analysisViewManager.detach(), _this._teardown()) : e && !_this.ready && (y(_this.analysisViewManager) && _this.analysisViewManager.attach(), _this._startup(), _this.toolViewManager.attach());
    }, !0));
    return _this;
  }

  _createClass(z, [{
    key: "initialize",
    value: function initialize() {
      var _this2 = this;

      this.addResolvingPromise(this.validate().then(function () {
        return _this2._isValid = !0, v(_this2, "ready");
      })), this.basemapView = new b({
        view: this
      }), this.layerViewManager = new C({
        view: this,
        layerViewImporter: {
          importLayerView: function importLayerView(e) {
            return _this2.importLayerView(e);
          },
          hasLayerViewModule: function hasLayerViewModule(e) {
            return _this2.hasLayerViewModule(e);
          }
        },
        supportsGround: this.supportsGround
      }), this.toolViewManager = new I({
        view: this
      }), this._setupSpatialReferenceLogger(), this.handles.add([w(function () {
        return _this2.initialExtentRequired;
      }, function (e) {
        return _this2.defaultsFromMap.required = _objectSpread(_objectSpread({}, _this2.defaultsFromMap.required), {}, {
          extent: e
        });
      }, {
        sync: !0,
        initial: !0
      }), w(function () {
        return _this2.ready;
      }, function (e) {
        _this2.defaultsFromMap && (_this2.defaultsFromMap.suspended = e, _this2.defaultsFromMap.userSpatialReference = e ? _this2.spatialReference : _this2._userSpatialReference);
      }, {
        sync: !0
      }), w(function () {
        return _this2._userSpatialReference;
      }, function (e) {
        _this2.defaultsFromMap && (_this2.defaultsFromMap.userSpatialReference = e);
      }, {
        sync: !0,
        initial: !0
      })]);
    }
  }, {
    key: "_setupSpatialReferenceLogger",
    value: function _setupSpatialReferenceLogger() {
      var _this3 = this;

      var e = null;
      this.handles.add([w(function () {
        var e;
        return null == (e = _this3.defaultsFromMap) ? void 0 : e.ready;
      }, function (t) {
        var i;
        var r = (null == (i = _this3.map) ? void 0 : i.allLayers.length) > 0;

        if (t && !_this3.spatialReference && r) {
          if (y(e)) return;

          var _t = p(function () {
            return e = c(e);
          });

          e = f( /*#__PURE__*/function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t) {
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.prev = 0;
                      _context.next = 3;
                      return g(_this3.spatialReferenceWarningDelay, null, t);

                    case 3:
                      _context.next = 8;
                      break;

                    case 5:
                      _context.prev = 5;
                      _context.t0 = _context["catch"](0);
                      return _context.abrupt("return");

                    case 8:
                      _context.prev = 8;
                      e = null;
                      return _context.finish(8);

                    case 11:
                      P.warn("#spatialReference", "no spatial reference could be derived from the currently added map layers");

                    case 12:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, null, [[0, 5, 8, 11]]);
            }));

            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }()), _this3.handles.add(_t, "spatial-reference-logger-task");
        } else _this3.handles.remove("spatial-reference-logger-task");
      }, {
        sync: !0
      })]);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.destroyed) return;
      this.viewEvents.destroy(), this.allLayerViews.destroy(), this.navigation && (this.navigation.destroy(), this._set("navigation", null)), this.graphics = u(this.graphics), this.analyses = u(this.analyses), this.handles.remove("defaultsFromMap"), this.defaultsFromMap.destroy(), this._set("defaultsFromMap", null), this.toolViewManager = u(this.toolViewManager), this.layerViewManager = u(this.layerViewManager), this.basemapView = u(this.basemapView), this.invalidate(), this._emitter.clear(), this.handles.removeAll();
      var e = this.map;
      this.map = null, null == e || e.destroy();
    }
  }, {
    key: "_startup",
    value: function _startup() {
      this._set("ready", !0);
    }
  }, {
    key: "_teardown",
    value: function _teardown() {
      this._set("ready", !1);
    }
  }, {
    key: "whenReady",
    value: function whenReady() {
      return Promise.resolve(this);
    }
  }, {
    key: "toMap",
    value: function toMap() {
      return P.error("#toMap()", "Not implemented on this instance of View"), null;
    }
  }, {
    key: "_defaultsFromMapSettings",
    get: function get() {
      return {};
    }
  }, {
    key: "defaultsFromMap",
    get: function get() {
      var _this4 = this;

      return new k(_objectSpread({
        required: {
          tileInfo: !1,
          heightModelInfo: !1,
          extent: !1
        },
        map: function map() {
          return _this4.map;
        },
        getSpatialReferenceSupport: function getSpatialReferenceSupport(e) {
          return _this4.getSpatialReferenceSupport(e);
        }
      }, this._defaultsFromMapSettings));
    }
  }, {
    key: "heightModelInfo",
    get: function get() {
      return this.getDefaultHeightModelInfo();
    }
  }, {
    key: "interacting",
    get: function get() {
      return this.navigating;
    }
  }, {
    key: "preconditionsReady",
    get: function get() {
      var e;
      return !(this.fatalError || !this._isValid || this._readyCycleForced || !this.map || d.isLoadable(this.map) && !this.map.loaded || 0 === this.width || 0 === this.height || !this.spatialReference || !this.typeSpecificPreconditionsReady || !this._validateSpatialReference(this.spatialReference) || !(this._currentSpatialReference || null != (e = this.defaultsFromMap) && e.ready));
    }
  }, {
    key: "map",
    set: function set(e) {
      var t;
      e !== this._get("map") && (null != (t = e) && t.destroyed && (P.warn("#map", "The provided map is already destroyed", {
        map: e
      }), e = null), d.isLoadable(e) && e.load().catch(function () {}), this.initialized && (this.forceReadyCycle(), this._currentSpatialReference = null), this._set("map", e));
    }
  }, {
    key: "spatialReference",
    get: function get() {
      var e, t;
      var i = this._userSpatialReference || this._currentSpatialReference || this.getDefaultSpatialReference() || null;
      return i && null != (e = this.defaultsFromMap) && null != (t = e.required) && t.heightModelInfo && (i = i.clone(), i.vcsWkid = this.defaultsFromMap.vcsWkid, i.latestVcsWkid = this.defaultsFromMap.latestVcsWkid), i;
    },
    set: function set(e) {
      this._userSpatialReference = e, this._set("spatialReference", e);
    }
  }, {
    key: "stationary",
    get: function get() {
      return !this.animation && !this.navigating && !this.resizing;
    }
  }, {
    key: "initialExtent",
    get: function get() {
      var e;
      return null == (e = this.defaultsFromMap) ? void 0 : e.extent;
    }
  }, {
    key: "cursor",
    get: function get() {
      var e = this.toolViewManager ? this.toolViewManager.cursor : null;
      return y(e) ? e : this._cursor || "default";
    },
    set: function set(e) {
      this._cursor = e, this.notifyChange("cursor");
    }
  }, {
    key: "size",
    get: function get() {
      return [this.width, this.height];
    }
  }, {
    key: "whenLayerView",
    value: function whenLayerView(e) {
      return this.layerViewManager.whenLayerView(e);
    }
  }, {
    key: "getDefaultSpatialReference",
    value: function getDefaultSpatialReference() {
      var e;
      return null == (e = this.defaultsFromMap) ? void 0 : e.spatialReference;
    }
  }, {
    key: "getDefaultHeightModelInfo",
    value: function getDefaultHeightModelInfo() {
      var e, t, i;
      return null != (e = null != (t = this.map && "heightModelInfo" in this.map ? this.map.heightModelInfo : void 0) ? t : null == (i = this.defaultsFromMap) ? void 0 : i.heightModelInfo) ? e : null;
    }
  }, {
    key: "importLayerView",
    value: function importLayerView(e) {
      throw new o("importLayerView() not implemented");
    }
  }, {
    key: "hasLayerViewModule",
    value: function hasLayerViewModule(e) {
      return !1;
    }
  }, {
    key: "validate",
    value: function () {
      var _validate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function validate() {
        return _validate.apply(this, arguments);
      }

      return validate;
    }()
  }, {
    key: "invalidate",
    value: function invalidate() {
      this._isValid = !1;
    }
  }, {
    key: "getSpatialReferenceSupport",
    value: function getSpatialReferenceSupport() {
      return {};
    }
  }, {
    key: "_validateSpatialReference",
    value: function _validateSpatialReference(e) {
      return y(this.getSpatialReferenceSupport({
        spatialReference: e
      }));
    }
  }, {
    key: "when",
    value: function when(e, t) {
      return this.isResolved() && !this.ready && P.warn("#when()", 'Calling view.when() while the view is no longer ready but was already resolved once will resolve immediately. Use watchUtils.whenOnce(view, "ready").then(...) instead.'), _get(_getPrototypeOf(z.prototype), "when", this).call(this, e, t);
    }
  }, {
    key: "forceReadyCycle",
    value: function forceReadyCycle() {
      var _this5 = this;

      this.ready && (M(this, "preconditionsReady", function () {
        return _this5._readyCycleForced = !1;
      }), this._readyCycleForced = !0);
    }
  }, {
    key: "addAndActivateTool",
    value: function addAndActivateTool(e) {
      this.toolViewManager.tools.add(e), this.activeTool = e;
    }
  }, {
    key: "tryFatalErrorRecovery",
    value: function tryFatalErrorRecovery() {
      this.fatalError = null;
    }
  }]);

  return z;
}(l(n.EventedMixin(m(r))));

U.views = new a(), e([R()], U.prototype, "_userSpatialReference", void 0), e([V("toolViewManager.activeTool")], U.prototype, "activeTool", void 0), e([R({
  readOnly: !0
})], U.prototype, "allLayerViews", void 0), e([R()], U.prototype, "groundView", void 0), e([R()], U.prototype, "animation", void 0), e([R()], U.prototype, "basemapView", void 0), e([R({
  readOnly: !0
})], U.prototype, "_defaultsFromMapSettings", null), e([R()], U.prototype, "defaultsFromMap", null), e([R()], U.prototype, "fatalError", void 0), e([R({
  type: j
})], U.prototype, "extent", void 0), e([R(S(E, "graphics"))], U.prototype, "graphics", void 0), e([R(S(L, "analyses"))], U.prototype, "analyses", void 0), e([R({
  readOnly: !0,
  type: F
})], U.prototype, "heightModelInfo", null), e([R({
  readOnly: !0
})], U.prototype, "interacting", null), e([R({
  readOnly: !0
})], U.prototype, "navigating", void 0), e([R({
  readOnly: !0,
  dependsOn: ["fatalError", "_isValid", "_readyCycleForced", "map", "map.loaded?", "width", "height", "spatialReference", "_currentSpatialReference", "defaultsFromMap.ready", "typeSpecificPreconditionsReady"]
})], U.prototype, "preconditionsReady", null), e([R({
  readOnly: !0
})], U.prototype, "typeSpecificPreconditionsReady", void 0), e([R({
  type: a,
  readOnly: !0
})], U.prototype, "layerViews", void 0), e([R({
  type: x
})], U.prototype, "magnifier", void 0), e([R({
  value: null,
  type: t
})], U.prototype, "map", null), e([R()], U.prototype, "padding", void 0), e([R({
  readOnly: !0
})], U.prototype, "ready", void 0), e([R({
  type: O
})], U.prototype, "spatialReference", null), e([R()], U.prototype, "spatialReferenceWarningDelay", void 0), e([R()], U.prototype, "stationary", null), e([R({
  readOnly: !0
})], U.prototype, "supportsGround", void 0), e([R({
  type: i
})], U.prototype, "timeExtent", void 0), e([V("toolViewManager.tools")], U.prototype, "tools", void 0), e([R()], U.prototype, "toolViewManager", void 0), e([R({
  readOnly: !0
})], U.prototype, "type", void 0), e([R({
  type: Number
})], U.prototype, "scale", void 0), e([R({
  readOnly: !0
})], U.prototype, "updating", void 0), e([R({
  readOnly: !0
})], U.prototype, "initialExtentRequired", void 0), e([R({
  readOnly: !0,
  type: j
})], U.prototype, "initialExtent", null), e([R()], U.prototype, "cursor", null), e([R({
  readOnly: !0
})], U.prototype, "input", void 0), e([R({
  type: T,
  nonNullable: !0
})], U.prototype, "navigation", void 0), e([R()], U.prototype, "layerViewManager", void 0), e([R()], U.prototype, "analysisViewManager", void 0), e([R()], U.prototype, "width", void 0), e([R()], U.prototype, "height", void 0), e([R({
  readOnly: !0
})], U.prototype, "resizing", void 0), e([R({
  value: null,
  readOnly: !0
})], U.prototype, "size", null), e([R({
  readOnly: !0
})], U.prototype, "suspended", void 0), e([R({
  readOnly: !0
})], U.prototype, "viewEvents", void 0), e([R({
  readOnly: !0
})], U.prototype, "persistableViewModels", void 0), e([R()], U.prototype, "_isValid", void 0), e([R()], U.prototype, "_readyCycleForced", void 0), e([R()], U.prototype, "_currentSpatialReference", void 0), U = _z = e([_("esri.views.View")], U);
var W = U;
export { W as default };